import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustedBy from "@/components/site/TrustedBy";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import StatsCases from "@/components/site/StatsCases";
import Methodology from "@/components/site/Methodology";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="bg-white text-neutral-950 selection:bg-[#002FA7] selection:text-white">
      <Header />
      <Hero />
      <TrustedBy />
      <Services />
      <Industries />
      <StatsCases />
      <Methodology />
      <Contact />
      <Footer />
    </main>
  );
}
